import { render, staticRenderFns } from "./DeletedList.vue?vue&type=template&id=26f6048e&scoped=true&"
import script from "./DeletedList.vue?vue&type=script&lang=js&"
export * from "./DeletedList.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=26f6048e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f6048e",
  null
  
)

export default component.exports